import { AutocompletePredictionRestrictionTypes } from '../types';
import { CountryCodeList } from 'types/countries';
import { categorizePredictions } from '../predictionClassifier';
import { fetchPlacePredictions, requireAutocompleteService } from './placePredictions';

// eXp Commercial search: 2 requests, US only. (regions) adds states and partial
// ZIP matches (e.g. "902") that geocode alone misses.
// Cost: one 5-type request (locality, administrative_area_level_1, postal_code,
// route, street_address) would halve this but returns 4 of 5 partial ZIPs.
export async function queryCommercialPlaces(input: string) {
  const autocompleteService = await requireAutocompleteService();
  // US only: /listings is gated by the expCommercialEnabled feature, which only
  // exp-commercial-us sets. If another tenant gets it, pass that tenant's
  // localization.countries in from the caller.
  const country = [CountryCodeList.UNITED_STATES];
  // Same two billed requests, started together so the slower one does not wait.
  const [geocodePredictions, regionPredictions] = await Promise.all([
    fetchPlacePredictions(autocompleteService, input, AutocompletePredictionRestrictionTypes.GEOCODE, country),
    fetchPlacePredictions(autocompleteService, input, AutocompletePredictionRestrictionTypes.REGIONS, country),
  ]);
  return categorizePredictions([...geocodePredictions, ...regionPredictions]);
}
